import React from 'react';

type TProps = {
  label: string | JSX.Element;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  style: string;
  bottomText?: string;
  maxLength?: number;
  minLength?: number;
  type?: string;
  readonly?: boolean;
};
const Input = ({
  handleChange = () => {
    return;
  },
  label,
  value,
  style,
  bottomText,
  maxLength,
  minLength,
  type,
  readonly = false,
}: TProps) => {
  return (
    <div className={['w-full text-xs mb-4', style].join(' ')}>
      <h4 className='text-[#212121] text-[13px] font-poppins font-normal leading-[18px] pb-[5px] w-full'>
        {label}
      </h4>
      <div className='flex flex-row gap-3 w-full'>
        <div className='w-full'>
          {/* <label className='flex flex-col relative text-[#212121] '>Business name 1</label> */}
          <input
            className={[
              'w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none ',
              readonly && 'bg-[ bg-[#F0F6FE]',
            ].join(' ')}
            value={value ?? ''}
            placeholder={''}
            onChange={(e) => handleChange(e)}
            maxLength={maxLength}
            minLength={minLength}
            type={type}
            readOnly={readonly}
          />
        </div>
      </div>
      {bottomText && <div className='text-[#768396] mt-2 text-xs'>{bottomText}</div>}
    </div>
  );
};

export default Input;
